import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f0d4c48")

_pushScopeId("data-v-0f0d4c48")
const _hoisted_1 = { class: "SurveyPanel" }
const _hoisted_2 = {
  key: 0,
  class: "SurveyPanel__content"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Опрос клиентов: ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "content__footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Подтвердить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_radio_group = _resolveComponent("s-radio-group")!
  const _component_s_text_area = _resolveComponent("s-text-area")!
  const _component_s_button = _resolveComponent("s-button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.is_loaded && !_ctx.state.is_completed && _ctx.state.survey)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("p", null, [
            _hoisted_3,
            _createVNode("b", null, "'" + _toDisplayString(_ctx.state.survey.title) + "'", 1)
          ]),
          (_ctx.state.survey.description)
            ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.state.survey.description), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_s_radio_group, {
            value: _ctx.state.selected_variant,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.selected_variant = $event)),
            theme: "green",
            label: "title",
            options: _ctx.state.survey.variants,
            disabled: _ctx.state.is_sending
          }, null, 8, ["value", "options", "disabled"]),
          (_ctx.isSelfVariant)
            ? (_openBlock(), _createBlock(_component_s_text_area, {
                key: 1,
                placeholder: "Ваш вариант",
                value: _ctx.state.comment,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.comment = $event)),
                disabled: _ctx.state.is_sending,
                "is-invalid": !_ctx.state.comment
              }, null, 8, ["value", "disabled", "is-invalid"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", {
              class: "footer__cancel",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelAnswer && _ctx.cancelAnswer(...args)))
            }, "Нет, спасибо"),
            _createVNode(_component_s_button, {
              class: "green",
              loading: _ctx.state.is_sending,
              onClick: _ctx.sendAnswer
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})